import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import { FormProps } from "../../components/form/interface/formInterface";
import SmallForm from "../../components/form/small_form";
import AdminAPI from "../../api/admin";
import API from "../../api/api";
import { useSetRecoilState } from "recoil";
import { loadingState } from "../../recoil/loading.atom";
import GAMEAPI from "../../api/game";

const ClubCreate = () => {
  const mode = "S";
  const setIsLoading = useSetRecoilState(loadingState);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [token, setToken] = useState("");
  const [profileType, setProfileType] = useState(0);
  const [nickName, setNickName] = useState("");

  const search = async () => {
    const res = await API.findByNickName(nickName);
    if (res && res.status === 200) {
      if (res.data.code === 4007) {
        alert(res.data.message);
      } else {
        if (!res.data.validate) {
          alert("본인인증하지 않은 유저입니다.");
        } else {
          if (window.confirm("해당 유저의 클럽을 개설 하시겠습니까?")) {
            console.log(res.data.accessToken);
            setToken(res.data.accessToken);
          }
        }
      }
    }
  };

  const formData: FormProps = {
    title: "상세정보",
    form: [
      {
        value: { value1: nickName, search: search },
        setValue: setNickName,
        label: "닉네임",
        type: "search-form",
        width: "100%",
      },
      {
        value: name,
        setValue: setName,
        label: "클럽 이름",
        type: "input",
        width: "100%",
      },
      {
        value: description,
        setValue: setDescription,
        label: "클럽 설명",
        type: "input",
        width: "100%",
      },
    ],
  };

  const save = async () => {
    if (window.confirm("개설 하시겠습니까?")) {
      setIsLoading(true);
      try {
        const res = await GAMEAPI.createClub(
          name,
          description,
          profileType,
          token
        );
        if (res && res.result === 1) {
          alert("개설되었습니다.");
        }
      } catch (error: any) {
        alert(error.response.data.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          클럽 개설
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            save={save}
            mode={mode}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default ClubCreate;
